import { createUseStyles } from 'react-jss';
import { designTokens } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    shadow: {
      all: 'initial',
    },

    default: {
      ...designTokens.colors,
      ...designTokens.spacing,
      ...designTokens.breakpoints,
      ...designTokens.typography,
      font: designTokens.typography['--tpBody01'],
    },

    light: {
      ...designTokens.light,
    },

    dark: {
      ...designTokens.dark,
    },
    hr: {
      color: 'pink',
    },
  },

  {
    name: 'CssBaseline',
  },
);
